module.exports = __webpack_public_path__ + "static/media/15.1f333cf2.jpg";